export const buildResolvedAction = _ref => {
  let {
    status,
    commonProps,
    statuses,
    actionHandlers,
    statusesCustomComponents
  } = _ref;
  const actionHandler = status ? actionHandlers == null ? void 0 : actionHandlers[status] : undefined;
  const base = commonProps && status && statuses[status] ? statuses[status]({
    ...commonProps,
    actionHandler
  }) : undefined;
  const autoInvoke = (commonProps == null ? void 0 : commonProps.autoInvoke) || (base && 'autoInvoke' in base ? base.autoInvoke : undefined);
  const StatusComponent = (status ? statusesCustomComponents == null ? void 0 : statusesCustomComponents[status] : undefined) ?? (base == null ? void 0 : base.StatusComponent);
  return {
    status,
    action: base == null ? void 0 : base.action,
    autoInvoke,
    StatusComponent: StatusComponent
  };
};
//# sourceMappingURL=buildResolvedAction.js.map